import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { TILE_COLORS, TileIconFrame } from './TileIconFrame';

const TEST_ID = 'Icon-LeagueTile';

/** League program avatar: a shield on the navy tile. */
export const LeagueTileIcon = ({ size = 'small', width, height }: IconProps) => (
    <TileIconFrame size={size} width={width} height={height} testId={TEST_ID}>
        <path
            d="M6.2 5.6L12.1 4.8L18 5.6V12.4189C18 14.4085 17.0137 16.2686 15.3669 17.3851L12.1 19.6L8.83305 17.3851C7.18625 16.2686 6.2 14.4085 6.2 12.4189V5.6Z"
            fill={TILE_COLORS.glyph}
        />
        <path
            d="M11.6 19.1V14.7C11.6 14.4239 11.8239 14.2 12.1 14.2C12.3761 14.2 12.6 14.4239 12.6 14.7V19.1C12.6 19.3761 12.3761 19.6 12.1 19.6C11.8239 19.6 11.6 19.3761 11.6 19.1Z"
            fill={TILE_COLORS.accent}
        />
        <path
            d="M11.6 7.4V5C11.6 4.72386 11.8239 4.5 12.1 4.5C12.3761 4.5 12.6 4.72386 12.6 5V7.4C12.6 7.67614 12.3761 7.9 12.1 7.9C11.8239 7.9 11.6 7.67614 11.6 7.4Z"
            fill={TILE_COLORS.accent}
        />
        <path
            d="M17.5 6.03672L12.1 5.3045L6.7 6.03672V12.419C6.70003 14.2427 7.60413 15.9479 9.11367 16.9713L12.1 18.9957L15.0863 16.9713C16.5959 15.9479 17.5 14.2427 17.5 12.419V6.03672ZM18.5 12.419C18.5 14.5743 17.4315 16.5895 15.6475 17.799L12.3807 20.0139C12.2112 20.1287 11.9888 20.1287 11.8193 20.0139L8.55254 17.799C6.76853 16.5895 5.70003 14.5743 5.7 12.419V5.6C5.7 5.34983 5.8849 5.13811 6.13281 5.1045L12.0328 4.3045L12.0664 4.30118C12.1 4.29891 12.1338 4.29997 12.1672 4.3045L18.0672 5.1045C18.3151 5.13811 18.5 5.34983 18.5 5.6V12.419Z"
            fill={TILE_COLORS.outline}
        />
        <path d="M12.1001 10L13.2259 11.8107H10.9742L12.1001 10Z" fill={TILE_COLORS.glyph} />
        <path
            d="M12.1001 9C12.4457 9 12.7668 9.17856 12.9493 9.47207L14.0751 11.2826C14.2668 11.591 14.2764 11.9791 14.1001 12.2965C13.9237 12.6139 13.5889 12.8107 13.2258 12.8107H10.9743C10.6112 12.8107 10.2764 12.6139 10.1001 12.2965C9.92369 11.9791 9.93334 11.591 10.1251 11.2826L11.2508 9.47207L11.2866 9.41836C11.4735 9.15687 11.776 9 12.1001 9ZM10.9742 11.8107H13.2259L12.1001 10L10.9742 11.8107Z"
            fill={TILE_COLORS.accent}
        />
    </TileIconFrame>
);
LeagueTileIcon.TEST_ID = TEST_ID;
